import { useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";

export default function AdminApp() {
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setAuthed(false);
      return;
    }
    api
      .get("/auth/me")
      .then(() => setAuthed(true))
      .catch(() => {
        setToken(null);
        setAuthed(false);
      });
  }, []);

  const logout = () => {
    setToken(null);
    setAuthed(false);
  };

  if (authed === null)
    return <div className="grid min-h-[100dvh] place-items-center bg-neutral-50 text-neutral-400">Cargando…</div>;

  return authed ? <AdminDashboard onLogout={logout} /> : <AdminLogin onLogin={() => setAuthed(true)} />;
}
